<template>
    <checkout-step>
        <template slot="title">
            <span @click="currentStep > 4 ? $parent.$parent.jumpTo(4) : null">
                {{ __('Vásárlói adatok') }}
            </span>
        </template>

        <portal-target
            v-if="portalAvailable"
            name="checkout-customer-data-before"
        />

        <component
            :is="formComponent"
            ref="form"
            v-bind="{ ...$attrs, ...$props }"
        />

        <portal-target
            v-if="portalAvailable"
            name="checkout-customer-data-after"
        />
    </checkout-step>
</template>

<script>
import checkoutStepBase from '@webapix/shop-js/src/mixins/checkoutStepBase'

export default {
    mixins: [checkoutStepBase],
    computed: {
        formComponent() {
            const type = this.checkoutData.isAuthenticated
                ? 'authenticated'
                : 'guest'

            return type + '-customer-data-form'
        },
    },
    methods: {
        next() {
            this.$loading.show()
            this.$refs.form.next()
        }
    }
}
</script>
